export const SCALE_PADDING = 16;
export const PREVIEW_GAP_PADDING = 48;

export const CSS_PROPERTIES = {
  DESKTOP_WIDTH: "--desktop-width",
  DESKTOP_HEIGHT: "--desktop-height",
  SCREEN_WIDTH: "--screen-width",
  BEZEL_TOP: "--bezel-top",
  BEZEL_BOTTOM: "--bezel-bottom",
  DESKTOP_SCALE: "--desktop-scale",
  DESKTOP_IFRAME_WIDTH: "--desktop-iframe-width",
  MOBILE_SCALE: "--mobile-scale",
  MOBILE_IFRAME_WIDTH: "--mobile-iframe-width",
};
